/**
 * Orders
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';
import { rulesOrderStatus } from '../../utils/rulesOrderStatus';
// Context
import { AuthConsumer } from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  cancelOrderAction,
  getAllOrdersReportAction,
  changeDeliveryTypeAction,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
} from './selectors';

// UI
import theme from '../../theme';
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  MenuItem,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Menu,
  DialogTitle,
  FormControl,
  Select,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiClose,
  mdiWarehouse,
  mdiTruckDeliveryOutline,
  mdiCity,
  mdiKey,
  mdiTruck,
  mdiPencilOutline,
  mdiPrinter,
} from '@mdi/js';

// Components
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import type { Filter } from '../../utils/listDaynamicFilter';
import List from './vipOrderList';
import Can from '../../components/Can';
import CSV from './csv';
import ExelExport from './components/exelExport';
import AlopeykRequest from './components/alopeykRequest';

// Helper
import {
  removeEmptyValueObject,
  translateSendDeliveryType,
  flattenObject,
  translateOrderStatus,
  translateOrderTransportationType,
  OrderTransportationType,
} from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  Payload,
  cancelPayload,
  PayloadAllUpdate,
  PayloadChangeDeliveryType,
  Status,
  Order,
} from './interfaces';
import { mdiCityVariantOutline } from '@mdi/js/commonjs/mdi';

// apis
import { GetAllOrdersRequestBuilder } from 'client-sdk/src/orders/orders';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import { Response3PL } from './components/response3Pl';
import Modal from '../../components/Modal';
import useQuery from '../../utils/hook/useQuery';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      '& .MuiFormGroup-row': {
        justifyContent: 'space-around',
      },
    },
  })
);

const VipOrders: FunctionComponent<Props> = (props: Props) => {
  const token = localStorage.getItem('token') || '';
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    'deliveryType.equals': 'VIP',
    page: 0,
    size: 100,
  } as any);
  const openMenu = Boolean(anchorEl);

  const [id, setId] = useState(-1 as number);
  const [changeType, setChangeType] = useState(false as boolean);
  const [sendType, setSendType] = useState<null | string>(null);
  const [confirmDialog, setConfirmDialog] = useState(false as boolean);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const [changeTransportationType, setChangeTransportationType] = useState(
    false as boolean
  );
  const [openResponse3PL, setOpenResponse3PL] = useState(false as boolean);
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [result3PLs, setResult3PLs] = useState([]);
  const [request3PLLoading, setRequest3PLLoading] = useState(false as boolean);
  const [orderResults3PL, setOrderResults3PL] = useState([
    {
      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
    {
      id: 1234,
      status: 'FAILED',
      message: 'بارگذاری ناموفق',
    },
    {
      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
  ]);
  const [transportationValue, setTransportationValue] =
    useState<OrderTransportationType>('');
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openRequestConfirmation, setOpenRequestConfirmation] = useState(
    false as boolean
  );
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [loading, setLoading] = useState(false as boolean);
  const [allOrders, setAllOrders] = useState<Order[]>([]);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);

  const selectItem = (id: string, status?: string) => {
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex == -1 && selected.length > 0) {
      setSelectedStatus([...selectedStatus, status]);
      setSelected([...selected, id]);
    } else if (selectedIndex == -1 && selected.length == 0) {
      setSelectedStatus([status]);
      setSelected([id]);
    } else {
      const newList = [...selectedStatus];
      newList.splice(selectedIndex, 1);
      setSelectedStatus(newList);
      setSelected(selected.filter(el => el != id));
    }
  };
  const sizeCloseHandler = () => {
    setOpenSize(false);
  };
  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.ordersList.map((n: any) => n.id);
      const newSelectedStatus = props.ordersList.map((n: any) => n.status);
      setSelected(newSelecteds);
      setSelectedStatus(newSelectedStatus);
      return;
    }
    setSelected([]);
  };

  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerCity: 'آدرس:',
      'customerCity.equals': 'آدرس:',
      'customerCity.contais': 'آدرس:',
      centerName: 'انبار:',
      'centerName.equals': 'انبار:',
      'centerName.contains': 'انبار:',
      id: 'شناسه سفارش:',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'تاریخ تحویل',
      'deliveryDate.equals': 'تاریخ تحویل:',
      'deliveryDate.greaterThanOrEqual': 'تاریخ تحویل:',
      'deliveryDate.greaterThan': 'تاریخ تحویل:',
      'deliveryDate.lessThanOrEqual': 'تاریخ تحویل:',
      'deliveryDate.lessThan': 'تاریخ تحویل:',
      packagedDate: 'تاریخ تحویل به لجستیک:',
      'packagedDate.equals': 'تاریخ تحویل به لجستیک:',
      'packagedDate.greaterThanOrEqual': 'تاریخ تحویل به لجستیک:',
      'packagedDate.greaterThan': 'تاریخ تحویل به لجستیک:',
      'packagedDate.lessThanOrEqual': 'تاریخ تحویل به لجستیک:',
      'packagedDate.lessThan': 'تاریخ تحویل به لجستیک:',
      status: 'وضعیت سفارش:',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
      partnerName: 'شرکت:',
      'partnerName.equals': 'شرکت:',
      'partnerName.contains': 'شرکت:',
      weight: 'وزن:',
      'weight.equals': 'وزن:',
      'weight.contains': 'وزن:',
      length: 'ابعاد:',
      'length.equals': 'ابعاد:',
      'length.contains': 'ابعاد:',
    };
    return status[fieldName];
  };
  const handleOpenChangeType = (id: number) => {
    setChangeType(true);
    setId(id);
  };

  const handleCloseChangeType = () => {
    setChangeType(false);
  };

  const handleOpenChangeTransportationType = (id: number) => {
    setTransportationValue('');
    setChangeTransportationType(true);
    setId(id);
  };

  const handleCloseChangeTransportationType = () => {
    setChangeTransportationType(false);
  };

  const handleCloseRequestConfirmation = () => {
    setOpenRequestConfirmation(false);
  };

  const handleChangeTransportationValue = (e: any) => {
    setTransportationValue(e.target.value);
  };

  const handleSelectType = (type: string) => {
    setSendType(type);
    setConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setSendType(null);
    setConfirmDialog(false);
  };
  const modalCloseHandler = () => {
    setOpenResponse3PL(false);
    setChangeTransportationType(false);
    setOpenRequestConfirmation(false);
  };
  const handleSetOrders3PL = () => {
    setOrders3PL({
      body: { orderIds: [...id], tplCode: transportationValue },
      callback: () => {
        getOrders();
        if (transportationValue !== 'ALOPEYK') {
          setOpenResponse3PL(true);
        } else {
          setOpenAlopeykRequest(true);
        }
      },
    });
  };

  const get3PLs = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.get3PLs({
        payload,
      });
      setResult3PLs(response.data);
      callback && callback();
    } catch (error) {
      handleError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const setOrders3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.setOrders3PL({
        payload,
      });
      setOrderResults3PL(response.data);
      callback && callback();
    } catch (error) {
      handleError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const handleCallback = () => {
    handleCloseConfirmDialog();
    handleCloseChangeType();
  };

  const handleChangeSendType = async () => {
    try {
      props.changeDeliverTypeDispatch({
        id,
        body: sendType?.toString(),
        filters: filtersValues,
        callback: handleCallback,
      });
    } catch (err) {
      //
    }
  };

  useEffect(() => {
    getOrders();
    get3PLs({});
    setupFilters();
    const storedId = JSON.parse(localStorage.getItem('vipId'));
    setSelected(storedId);
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const storedId = JSON.parse(localStorage.getItem('vipId'));
    if (storedId) {
      localStorage.removeItem('vipId');
    }
    localStorage.setItem('vipId', JSON.stringify(selected));
  }, [selected]);
  const classes = useStyles();

  const getOrders = () => {
    const { page, size } = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
    });

    // skuId: {in: variants.join()}
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerCity.contains',
        label: 'شهر',
        icon: mdiCityVariantOutline,
      },
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام سفارش‌دهنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'trackingCode.equals',
        label: 'کد پیگیری',
        icon: mdiKey,
      },
      {
        type: 'input',
        id: 'partnerName.contains',
        label: 'شرکت',
        icon: mdiCity,
      },
      {
        type: 'input',
        id: 'sourceName.contains',
        label: 'مبدا (انبار/مرکز)',
        icon: mdiWarehouse,
      },
      {
        type: 'date-picker-time',
        id: 'created.greaterThanOrEqual',
        label: 'تاریخ ثبت سفارش از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker-time',
        id: 'created.lessThanOrEqual',
        label: 'تا تاریخ ثبت سفارش  ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: '  تا تاریخ تحویل ',
        icon: mdiCalendar,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        icon: mdiStateMachine,
        data: [
          'ORDERED',
          'DELIVERED_TO_POST',
          'DELIVERED_TO_CENTER',
          'SUPPLIED_IN_CENTER',
          'PACKAGED',
          'BUNDLED',
          'LOADED',
          'ARRIVED',
          'DELIVERED',
          'NOT_DELIVERED',
          'RETURNED',
          'CANCELLED',
          'REGISTERED_IN_3PL',
        ],
        translateType: 'order',
      },
      {
        type: 'select',
        id: 'bundleId.specified',
        label: 'وضعیت بسته',
        data: ['false', 'true'],
        translateType: 'bundle',
        icon: mdiPackageVariant,
      },
      {
        type: 'checkbox',
        id: 'tplType.in',
        label: 'نوع 3PL',
        icon: mdiTruck,
        data: [
          'NONE',
          'LINK_EXPRESS',
          'ALOPEYK',
          'TAROFF',
          'CHAPAR',
          'PETROEX',
        ],
        translateType: 'TPL',
      },
    ]);
  };
  let headCells = [];
  headCells = [
    { id: 'customerCity', label: 'آدرس', type: 'input' },
    { id: 'id', label: 'شناسه سفارش', type: 'input' },
    { id: 'centerName', label: 'مرکز/انبار', type: 'input' },
    {
      id: 'partnerName',
      label: 'شرکت',
      type: 'input',
    },
    {
      id: 'deliveryDate',
      label: 'تاریخ تحویل',
      type: 'date-picker',
    },
    {
      id: 'packagedDate',
      label: 'تاریخ تحویل به لجستیک',
      type: 'date-picker',
    },
    {
      id: 'weight',
      label: 'وزن',
      type: 'input',
    },
    {
      id: 'length',
      label: 'ابعاد',
      type: 'input',
    },
    {
      id: 'status',
      label: 'وضعیت سفارش',
      translate: 'Order',
      type: 'checkbox',
      checkbox: true,
      data: [
        'ORDERED',
        'DELIVERED_TO_POST',
        'DELIVERED_TO_CENTER',
        'SUPPLIED_IN_CENTER',
        'PACKAGED',
        'BUNDLED',
        'LOADED',
        'ARRIVED',
        'DELIVERED',
        'NOT_DELIVERED',
        'RETURNED',
        'CANCELLED',
        'REGISTERED_IN_3PL',
      ],
      translateType: 'Order',
      statusModel: rulesOrderStatus,
      selectIcon: mdiPencilOutline,
      statusType: 'Order',
    },
  ];
  const head = { headCells };

  const handleChangeOrderStatus = (val: { id: number; body: Status }) => {
    const { id, body } = val;
    setId(id);
    setPreviewState(body);
    if (body === 'NOT_DELIVERED' || body === 'RETURNED') {
      setCancelDescription('');
      setOpenConfirmCancel(true);
    } else {
      updateOrderStatus(id, body);
    }
  };

  const updateOrderStatus = (id: number, body: Status) => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: body, description: cancelDescription },
      pagination: filtersValues,
    });
    onClose();
  };

  const onClose = () => {
    setOpenConfirmCancel(false);
  };

  const getAllOrdersCsv = async (payload: any) => {
    try {
      setLoading(true);
      const makeRequest = new GetAllOrdersRequestBuilder()
        .params(flattenObject({ ...payload, sort: 'created,desc' }))
        .build();
      const client = new Client(token);
      const { data } = await client.execute(makeRequest);
      setAllOrders(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const groupStatusChange = (status: string) => {
    const checkList = new Array(...new Set(selectedStatus));
    if (checkList.length > 1) {
      setOpenAlertWarning(true);
      return;
    }
    const payload = {
      ids: selected,
      status,
      pagination: filtersValues,
    };
    props.updateAllOrderStatusDispatch(payload);
  };

  return (
    <AuthConsumer>
      {({ user }) => (
        <div className={classes.root}>
          <Grid container spacing={5}>
            <Grid container item xs={12} sm={6} alignItems="center">
              <Typography
                variant="h4"
                component="div"
                style={{ marginLeft: '20px', fontSize: '18px' }}
              >
                {'لیست سفارش‌ های ارسال ویژه'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <RenderFilter
                filters={filters}
                onFilter={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    'deliveryType.equals': 'VIP',
                    page: 0,
                    size: 100,
                  });
                }}
                mainFiltersCount={1}
                baseFilter={{
                  type: 'input',
                  id: 'id.equals',
                  placeholder: 'شناسه سفارش',
                }}
                filterValues={filtersValues}
              />
            </Grid>
            <Grid xs={12} sm={6} item container alignItems="center">
              {props.loading ? (
                ''
              ) : (
                <>
                  {props.ordersList.length > 0 && (
                    <>
                      <div className={classes.subtitle}>
                        {'تعداد کل سفارش‌ها:'}
                      </div>
                      <div>
                        &nbsp;
                        <b>{`${props.count}`}</b>
                      </div>
                    </>
                  )}
                </>
              )}
            </Grid>
            <Grid
              container
              item
              xs={12}
              md={6}
              direction="row-reverse"
              alignItems="center"
            >
              <div className={classes.btnBox}>
                <>
                  <CSV
                    ordersDispatch={getAllOrdersCsv}
                    data={allOrders}
                    filtersValues={filtersValues}
                    loading={loading}
                  />
                  <ExelExport
                    data={allOrders}
                    loading={loading}
                    filtersValues={filtersValues}
                    handleRequest={getAllOrdersCsv}
                  />
                </>
                {selected.length >= 1 && (
                  <React.Fragment>
                    <Button
                      style={{ marginLeft: '5px' }}
                      variant="contained"
                      color="primary"
                      onClick={handleOpenMenu}
                      aria-controls="basic-menu"
                      aria-haspopup="true"
                      aria-expanded={openMenu ? 'true' : undefined}
                    >
                      تغییر وضعیت گروهی
                    </Button>
                    <Menu
                      id="group-status"
                      aria-labelledby="group-status"
                      anchorEl={anchorEl}
                      open={openMenu}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                    // transformOrigin={{
                    //   vertical: 'top',
                    //   horizontal: 'center',
                    // }}
                    >
                      {rulesOrderStatus[selectedStatus[0]]?.map(
                        (item: any, index: number) => (
                          <MenuItem onClick={() => groupStatusChange(item)}>
                            {translateOrderStatus(item)}
                          </MenuItem>
                        )
                      )}
                    </Menu>
                    <Button
                      style={{ marginLeft: '5px' }}
                      variant="contained"
                      color="primary"
                      onClick={() => handleOpenChangeTransportationType(id)}
                    >
                      انتخاب سرویس ارسال
                    </Button>
                    <IconButton
                      onClick={() => {
                        const win = window.open(
                          `/3pl-print-labels/${id}`,
                          '_blank'
                        )!;
                      }}
                      style={{
                        border: '2px solid ',
                        marginLeft: '5px',
                        borderRadius: '5px',
                      }}
                    >
                      <Icon path={mdiPrinter} size={1} color={'primary'} />
                    </IconButton>
                  </React.Fragment>
                )}
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {props.ordersList.length > 0 ? (
                    <List
                      loading={props.loading}
                      data={props.ordersList}
                      handleOpenConfirmUpdateState={handleChangeOrderStatus}
                      handleOpenChangeType={handleOpenChangeType}
                      handleOpenChangeTransportationType={
                        handleOpenChangeTransportationType
                      }
                      selectItem={selectItem}
                      selectedItems={selected}
                      selectAll={handleSelectAllClick}
                      head={head}
                      filterVal={filtersValues}
                      onFilterValue={(filtervalues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtervalues),
                          ...filtersValues,
                          page: 0,
                          size: 10,
                        });
                      }}
                      removeFilterHandler={removeFilterHandler}
                      filterLabelTranslator={filterTranslator}
                    />
                  ) : (
                    // <Helper
                    //   removeFilterHandler={removeFilterHandler}
                    //   sizeChanged={sizeChangeHandler}
                    //   pageChanged={pageChangeHandler}
                    //   count={props.count}
                    //   data={props.ordersList}
                    //   head={head}
                    //   filterVal={filtersValues}
                    //   onFilterValue={(filtervalues: any) => {
                    //     setFiltersValues({
                    //       ...removeEmptyValueObject(filtervalues),
                    //       ...filtersValues,
                    //       page: 0,
                    //       size: 10,
                    //     });
                    //   }}
                    //   filterLabelTranslator={filterTranslator}
                    //   changeStatus={handleChangeOrderStatus}
                    //   checkbox={true}
                    //   setSelectedId={setSelectedId}
                    // >
                    //   {(row: any) => {
                    //     return (
                    //       <div>
                    //         <IconButton
                    //           aria-label="changeAction"
                    //           size="small"
                    //           title="نوع ارسال سفارش"
                    //           data-cy="changeAction"
                    //           onClick={() =>
                    //             handleOpenChangeTransportationType([row.id])
                    //           }
                    //         >
                    //           {(!row.orderTPLType ||
                    //             row.orderTPLType === 'RONAD') && (
                    //             <Icon
                    //               path={
                    //                 !row.orderTPLType
                    //                   ? mdiTruckOutline
                    //                   : mdiTruck
                    //               }
                    //               color={
                    //                 !row.bundleId && theme.palette.gray.main
                    //               }
                    //               size={1}
                    //             />
                    //           )}
                    //           {row.orderTPLType &&
                    //             row.orderTPLType !== 'RONAD' && (
                    //               <img
                    //                 style={{
                    //                   width: '30px',
                    //                   objectFit: 'contain',
                    //                 }}
                    //                 src={
                    //                   row.orderTPLType === 'ALOPEYK'
                    //                     ? '/alopeyk.png'
                    //                     : row.orderTPLType === 'TAROFF'
                    //                     ? '/taarof.png'
                    //                     : row.orderTPLType === 'LINK_EXPRESS'
                    //                     ? '/link-express.png'
                    //                     : ''
                    //                 }
                    //                 alt={row.orderTPLType}
                    //               />
                    //             )}
                    //         </IconButton>
                    //         {!row.orderTPLType && (
                    //           <Link to={`/nonPost-orders/${row.id}`}>
                    //             <IconButton
                    //               aria-label="details"
                    //               size="small"
                    //               title="جزئیات سفارش"
                    //               data-cy="details"
                    //             >
                    //               <Icon
                    //                 path={mdiFileDocumentOutline}
                    //                 size={1}
                    //                 color={theme.palette.green.main}
                    //               />
                    //             </IconButton>
                    //           </Link>
                    //         )}
                    //         {row.orderTPLType && (
                    //           <Link to={`/nonPost-orders/3pl-orders/${row.id}`}>
                    //             <IconButton
                    //               aria-label="details"
                    //               size="small"
                    //               title="جزئیات سفارش 3PL"
                    //               data-cy="details"
                    //             >
                    //               <Icon
                    //                 path={mdiFileDocumentOutline}
                    //                 size={1}
                    //                 color={theme.palette.green.main}
                    //               />
                    //             </IconButton>
                    //           </Link>
                    //         )}
                    //         <IconButton
                    //           aria-label="changeAction"
                    //           size="small"
                    //           title="تغییر نوع ارسال سفارش"
                    //           data-cy="changeAction"
                    //           onClick={() => handleOpenChangeType([row.id])}
                    //         >
                    //           <Icon
                    //             path={mdiPlusBoxMultipleOutline}
                    //             size={1}
                    //             color={theme.palette.orange.main}
                    //           />
                    //         </IconButton>
                    //         <Can
                    //           role={authContext.user.role}
                    //           perform="orders:byBundle"
                    //           yes={() =>
                    //             (row.status === 'BUNDLED' ||
                    //               row.status === 'DELIVERED' ||
                    //               row.status === 'LOADED' ||
                    //               row.status === 'ARRIVED') &&
                    //             row.status &&
                    //             row.bundleId ? (
                    //               <Link to={`/bundles/${row.bundleId}`}>
                    //                 <IconButton
                    //                   aria-label="bundle"
                    //                   size="small"
                    //                   title="نمایش سفارش در بسته "
                    //                   color="secondary"
                    //                 >
                    //                   <Icon
                    //                     path={mdiPackageVariantClosed}
                    //                     size={1}
                    //                     color={theme.palette.blue.main}
                    //                   />
                    //                 </IconButton>
                    //               </Link>
                    //             ) : (
                    //               <IconButton
                    //                 aria-label="bundle"
                    //                 size="small"
                    //                 title="بسته‌بندی نشده"
                    //                 disabled
                    //                 color="default"
                    //                 style={{pointerEvents: 'fill'}}
                    //               >
                    //                 <Icon
                    //                   path={mdiPackageVariantClosed}
                    //                   size={1}
                    //                 />
                    //               </IconButton>
                    //             )
                    //           }
                    //         />
                    //         <Link to={`/orders/${row.id}/allLogs`}>
                    //           <IconButton size="small" title="تاریخچه سفارش">
                    //             <Icon path={mdiHistory} size={1} />
                    //           </IconButton>
                    //         </Link>
                    //       </div>
                    //     );
                    //   }}
                    // </Helper>
                    <Typography variant="h3" component="div">
                      سفارشی موجود نیست
                    </Typography>
                  )}
                </>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {props.ordersList.length > 0 && (
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={sizeCloseHandler}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              {props.ordersList.length > 0 && (
                <Pagination
                  className={classes.pagination}
                  count={Math.ceil(props.count / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              )}
            </Grid>
          </Grid>

          <Dialog
            fullWidth
            open={openAlertWarning}
            onClose={() => setOpenAlertWarning(false)}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
            <DialogContent>
              وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => setOpenAlertWarning(false)}
                variant="contained"
                color="primary"
              >
                {'متوجه شدم'}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={changeType}
            fullWidth
            onClose={handleCloseChangeType}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton aria-label="close" onClick={handleCloseChangeType}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiTruckDeliveryOutline}
                  size={4}
                  color={theme.palette.blue.main}
                />
              </div>

              <div className={classes.cancelTitle}>انتخاب نوع حمل</div>

              <div className={classes.typeSection}>
                <Button
                  variant="contained"
                  onClick={handleSelectType.bind(this, 'POST')}
                  size="large"
                >
                  پست
                </Button>
                <Button
                  variant="contained"
                  style={{ marginRight: '1rem' }}
                  onClick={handleSelectType.bind(this, 'DELIVER_IN_RONAD')}
                  size="large"
                >
                  تحویل در انبار
                </Button>
                <Button
                  variant="contained"
                  style={{ marginRight: '1rem' }}
                  onClick={handleSelectType.bind(this, 'COURIER')}
                  size="large"
                >
                  لجستیک
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={changeTransportationType}
            fullWidth
            onClose={handleCloseChangeTransportationType}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton
                  aria-label="close"
                  onClick={handleCloseChangeTransportationType}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiTruckDeliveryOutline}
                  size={4}
                  color={theme.palette.orange.main}
                />
              </div>

              <div className={classes.cancelTitle}>
                لطفا سرویس مورد نظر خود را انتخاب کنید
              </div>

              <div className={classes.typeSection}>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={transportationValue}
                  onChange={handleChangeTransportationValue}
                >
                  {result3PLs.map((tpl: any) => {
                    return (
                      <FormControlLabel
                        value={tpl.code}
                        control={<Radio />}
                        label={
                          <img
                            style={{ width: '50px', objectFit: 'contain' }}
                            src={
                              tpl.code === 'LINK_EXPRESS'
                                ? '/link-express.png'
                                : tpl.code === 'TAROFF'
                                  ? '/taarof.png'
                                  : tpl.code === 'CHAPAR'
                                    ? '/chapar.png'
                                    : tpl.code === 'PETROEX'
                                      ? '/Petroex.jpg'
                                      : '/alopeyk.png'
                            }
                            alt={tpl.name}
                          />
                        }
                      />
                    );
                  })}
                </RadioGroup>
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleCloseChangeTransportationType}
                    variant="outlined"
                    size="large"
                  >
                    {'انصراف'}
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    onClick={() => setOpenRequestConfirmation(true)}
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={!transportationValue}
                  >
                    {'تایید سرویس'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openRequestConfirmation}
            fullWidth
            onClose={handleCloseRequestConfirmation}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton
                  aria-label="close"
                  onClick={handleCloseRequestConfirmation}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiTruckDeliveryOutline}
                  size={4}
                  color={theme.palette.orange.main}
                />
              </div>

              <div style={{ margin: '50px 0' }} className={classes.cancelTitle}>
                آیا از ارسال درخواست به
                <strong>
                  {' '}
                  {translateOrderTransportationType(transportationValue)}{' '}
                </strong>
                مطمئن هستید ؟
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleCloseRequestConfirmation}
                    variant="outlined"
                    size="large"
                  >
                    {'انصراف'}
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    onClick={() => handleSetOrders3PL()}
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={request3PLLoading}
                  >
                    {'ارسال درخواست'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Modal
            maxWidth="lg"
            fullScreen
            onClose={modalCloseHandler}
            open={openResponse3PL}
            title={
              <div>
                <h3 style={{ padding: '0 20px' }}>
                  {'ارسال درخواست به '}
                  <strong>
                    {translateOrderTransportationType(transportationValue)}
                  </strong>
                </h3>
              </div>
            }
            content={<Response3PL data={orderResults3PL} />}
          />

          <Modal
            maxWidth="lg"
            fullScreen
            onClose={() => setOpenAlopeykRequest(false)}
            open={openAlopeykRequest}
            title={
              <div>
                <h3
                  style={{
                    display: 'flex',
                    marginBottom: 0,
                    alignItems: 'center',
                  }}
                >
                  {`ارسال درخواست سفارش 
                   ${id} 
                    به `}
                  <strong>
                    {translateOrderTransportationType(transportationValue)}
                  </strong>
                  <img
                    style={{
                      width: '60px',
                      objectFit: 'contain',
                      margin: '0 20px',
                    }}
                    src={'/alopeyk.png'}
                    alt={'alopeyk'}
                  />
                </h3>
              </div>
            }
            content={
              <AlopeykRequest orderId={id} id={orderResults3PL[0]?.id} />
            }
          />

          <Dialog
            fullWidth
            open={confirmDialog}
            onClose={handleCloseConfirmDialog}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton
                  aria-label="close"
                  onClick={handleCloseConfirmDialog}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.cancelTitle}>
                آیا از انتخاب {sendType && translateSendDeliveryType(sendType)}{' '}
                برای شیوه ارسال سفارش {id} مطمئنید؟
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleCloseConfirmDialog}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {'خیر'}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleChangeSendType}
                    size="large"
                  >
                    {'بله'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Dialog
            fullWidth
            open={openConfirmCancel}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {onClose ? (
                  <IconButton aria-label="close" onClick={onClose}>
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.cancelIcon}>
                <Icon
                  path={mdiClose}
                  size={4}
                  color={theme.palette.error.main}
                />
              </div>
              <div className={classes.cancelTitle}>
                {`از تغییر وضعیت سفارش با شناسه ${id} 
              به
              "${translateOrderStatus(previewState)}"
              مطمئن هستید؟`}
              </div>
              <TextField
                fullWidth
                id="description"
                name="description"
                className={classes.textArea}
                placeholder={'علت عدم تحویل...'}
                value={cancelDescription}
                onChange={e => setCancelDescription(e.target.value)}
              />
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={1}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={() => setOpenConfirmCancel(false)}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {'خیر'}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    onClick={() => updateOrderStatus(id, previewState)}
                    variant="contained"
                    size="large"
                    disabled={!(cancelDescription.length > 0)}
                  >
                    {'بله'}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
    changeDeliverTypeDispatch: (payload: PayloadChangeDeliveryType) =>
      dispatch(changeDeliveryTypeAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(VipOrders);
